var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFourthPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 128,
    viewBox: "0 0 111 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86918 94.3617V33.6613L55.4326 3.31678L107.996 33.6613V94.3617L55.4326 124.706L2.86918 94.3617Z",
    fill: "#C0BDC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 6.62207L105.127 35.3139V92.6976L55.4326 121.389L5.73837 92.6976V35.3139L55.4326 6.62207ZM55.4326 0L52.5634 1.65265L2.86918 30.3445L0 31.9971V96.0029L2.86918 97.6555L52.5634 126.347L55.4326 128L58.3018 126.347L107.996 97.6555L110.865 96.0029V32.0086L107.996 30.356L58.3018 1.65265L55.4326 0Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.127 92.6976L83.6195 79.9699L88.9906 44.5412L105.127 35.3139V92.6976Z",
    fill: "#979397"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 121.389L57.5214 101.076L83.6195 79.9699L105.127 92.6976L55.4326 121.389Z",
    fill: "#AFACB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2503 78.2025L5.73837 92.6976L55.4326 121.389L57.5214 101.076L24.2503 78.2025Z",
    fill: "#979397"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73837 92.6976L24.2503 78.2025L22.196 40.6965L5.73837 35.3139V92.6976Z",
    fill: "#5D5E60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.196 40.6965L55.4326 24.6405V6.62207L5.73837 35.3139L22.196 40.6965Z",
    fill: "#D2D0D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4326 24.6405L88.9906 44.5412L105.127 35.3139L55.4326 6.62207V24.6405Z",
    fill: "#5D5E60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7372 46.8365C67.7357 46.8365 68.585 47.1923 69.308 47.9154C70.0081 48.6154 70.3639 49.4647 70.3639 50.4632V77.5712C70.3639 78.5812 70.0081 79.4419 69.308 80.142C68.585 80.8421 67.7357 81.1979 66.7372 81.1979C65.7387 81.1979 64.8894 80.8421 64.1894 80.142C63.4893 79.4419 63.1335 78.5812 63.1335 77.5712V72.1542H44.151C42.8771 72.1542 41.8901 71.6378 41.167 70.5934C40.444 69.572 40.3063 68.4587 40.7539 67.2651L47.5252 49.2008C47.8809 48.2482 48.5121 47.5711 49.4303 47.1579C50.3369 46.7447 51.2551 46.7103 52.1847 47.0661C53.1143 47.4219 53.7915 48.0531 54.2046 48.9712C54.6178 49.8779 54.6522 50.796 54.2964 51.7256L49.3614 64.9239H63.1335V50.4632C63.1335 49.4647 63.4893 48.6154 64.1894 47.9154C64.8894 47.1923 65.7387 46.8365 66.7372 46.8365Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthPlace);
export default __webpack_public_path__ + "static/media/fourth-place.9394be663b008ecde105345cd673a82a.svg";
export { ForwardRef as ReactComponent };